import type { IconProps } from './types';
import './icons.css';

export default function Visa({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 25}
      height={height || 9}
      viewBox="0 0 25 9"
      className={`icon icon-visa ${className || ''}`}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 8.756H4.087L2.464 2.437c-.077-.29-.24-.548-.48-.669A6.944 6.944 0 0 0 0 1.1V.856h3.485c.481 0
        .842.366.902.79l.842 4.558L7.392.856h2.103l-3.245 7.9Zm4.448
        0H8.654l1.683-7.9h2.043l-1.682 7.9Zm4.326-5.711c.06-.426.42-.669.842-.669a3.74 3.74 0 0
        1 1.983.365l.36-1.701a5.08 5.08 0 0 0-1.862-.366c-1.983 0-3.426 1.094-3.426 2.613 0
        1.155 1.022 1.762 1.743 2.127.78.365 1.082.608 1.021.972 0 .547-.6.79-1.201.79a5.065 5.065 0
        0 1-2.104-.486l-.36 1.701a5.79 5.79 0 0 0 2.223.426c2.224.06 3.606-1.033 3.606-2.674
        0-2.066-2.825-2.187-2.825-3.098ZM25 8.755 23.377.857h-1.742a.905.905 0 0 0-.842.608l-3.005 7.292h2.104l.42-1.155h2.584l.24
        1.155H25Zm-3.064-5.771.6 2.977h-1.683l1.083-2.977Z"
        fill="#172B85"
      />
    </svg>
  );
}
